module.exports = __webpack_public_path__ + "static/media/emptythread.11f4dd7a.svg";